var helpers = require('./helpers');

module.exports = function FormTabsEngine (config) {

  if (!$.isPlainObject(config))
    return new Error('Parametr config musí být objekt');

  var loadedForms = [];
  var forms = {};
  var formTabsButton = $('.nav-tabs li');

  this.init = loadFormIntoTab;

  formTabsButton.click(handleTabClick);

  // prime presmerovani
  $('li.pronajem-autobusu-tabs').unbind('click');
  $('li.pronajem-autobusu-tabs a').unbind('click');

  for (var key in config) {

    var value = config[key];
    var elemId = `#${key}`;

    if (typeof value === 'string')
      forms[key] = helpers.prepareHtmlLoad(elemId, value);

    if ($.isArray(value) && $.isFunction($(elemId)[value[0]]))
      forms[key] = helpers.prepareWidget(elemId, value[0], value[1] || {});
  }

  if(window.location.hash) {
    handleTabClick(null, window.location.hash)
  }


  function handleTabClick (e, id = null) {
    var formId = id != null ? id.replace('#', '') : $(this).attr('aria-controls');

    var scrollmem = $('html,body').scrollTop()

    window.location.hash = `#${formId}`
    $('html,body').scrollTop(scrollmem)

    var form = $('#' + formId);

    loadFormIntoTab(formId);

    handleLoader(form);
  }

  function loadFormIntoTab (formId) {

    if (loadedForms.indexOf(formId) < 0 && $.isFunction(forms[formId]))
      forms[formId]();

    loadedForms.push(formId);
  }

  // handle na loader - odkryti loaderu po kliku, skryti loaderu na ubytovani a pronajmu aut, az je iframe nacteny
  function handleLoader(form) {
    var formId = form.attr('id');
    var loader =  form.find('.loader');

    loader.show();

    if (formId == 'form-7' || formId == 'form-8' ) {

      var checker = setInterval(function(){
        if (form.find('iframe').is(':visible')) {
          loader.hide();
          clearInterval(checker);
        }
      }, 10);
    }
  }
};
